var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, useContext, useState, useCallback, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { CheckboxInputStateContext } from '../../utils/InputStateContext';
import { Button, } from '../Button';
import { CheckboxIcon } from '../CheckboxIcon';
import { PickerOption, } from '../Picker';
import { PickerContext } from '../Picker/PickerContext';
import { TransparentOverlay } from './TransparentOverlay';
const checkboxContainerStyles = css `
  position: absolute;
  right: ${theme.spacing.x2};
  top: ${theme.spacing.x2};
`;
const labelStyles = css `
  ${theme.typeStyles.captionSmallStyles}
  background-color: ${theme.colors.gray100};
  bottom: 0;
  opacity: 80%;
  padding-bottom: ${theme.spacing.base};
  padding-left: 0;
  padding-right: 0;
  padding-top: ${theme.spacing.base};
  position: absolute;
  text-align: center;
  width: 100%;
`;
const optionContainerStyles = css `
  width: 100%;
  max-width: 100%;
`;
const optionStyles = css `
  align-items: center;
  aspect-ratio: 1/1;
  display: flex;
  height: auto;
  justify-content: center;
  max-width: 100%;
  position: relative;
  width: 100%;
`;
const editButtonStyles = css `
  display: flex;
  justify-content: center;
  width: 100%;
`;
const durationWidth = 60;
const durationStyles = css `
  ${theme.typeStyles.captionSmallStyles}
  color: ${theme.colors.textPrimary};
  background: rgba(255, 255, 255, 0.80);
  width: ${styleUtils.rem(durationWidth)};
  padding: ${theme.spacing.base};
  position: absolute;
  top: ${theme.spacing.x2};
  right: ${theme.spacing.x2};
  text-align: center;
`;
const PhotoSelectPickerOption = (_a) => {
    var { alt, duration, isDraggable, isEditButtonVisible, label, onDragEnd, onDragStart, onEditClick, src } = _a, pickerOptionProps = __rest(_a, ["alt", "duration", "isDraggable", "isEditButtonVisible", "label", "onDragEnd", "onDragStart", "onEditClick", "src"]);
    const { isLoading, selectedOptions, } = useContext(PickerContext);
    const isSelected = useMemo(() => (Array.isArray(selectedOptions)
        ? selectedOptions.includes(pickerOptionProps.value)
        : selectedOptions === pickerOptionProps.value), [
        selectedOptions,
        pickerOptionProps.value,
    ]);
    const isCheckboxVisible = useMemo(() => (!isLoading
        && (Array.isArray(selectedOptions)
            || isSelected)), [
        isLoading,
        isSelected,
        selectedOptions,
    ]);
    const imageStyles = useMemo(() => (css `
        height: auto;
        max-height: 100%;
        max-width: 100%;
        position: absolute;

        ${isLoading && css `
          opacity: ${styleUtils.disabledStateOpacity};
        `}
      `), [
        isLoading,
    ]);
    const [isHovering, setIsHovering,] = useState(false);
    const onPointerEnter = useCallback(() => {
        setIsHovering(true);
    }, []);
    const onPointerLeave = useCallback(() => {
        setIsHovering(false);
    }, []);
    const providerValue = useMemo(() => ({
        isHovering,
        isSelected,
    }), [
        isHovering,
        isSelected,
    ]);
    return (_jsxs("div", Object.assign({ css: optionContainerStyles, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave }, { children: [_jsx(PickerOption, Object.assign({}, pickerOptionProps, { disabled: isLoading || 'disabled' in pickerOptionProps ? pickerOptionProps.disabled : undefined }, { children: _jsxs("div", Object.assign({ css: optionStyles, draggable: isDraggable, onDragEnd: onDragEnd, onDragStart: onDragStart }, { children: [_jsx("img", { alt: alt, css: imageStyles, src: src }), Boolean(duration) && (_jsx("div", Object.assign({ css: durationStyles }, { children: duration }))), !isLoading
                            && (_jsx(TransparentOverlay, {})), _jsx("div", Object.assign({ css: checkboxContainerStyles }, { children: _jsx(CheckboxInputStateContext.Provider, Object.assign({ value: providerValue }, { children: isCheckboxVisible
                                    && (_jsx(CheckboxIcon, { checked: isSelected, shape: "circle", size: "medium" })) })) })), label
                            && (_jsx("div", Object.assign({ css: labelStyles }, { children: _jsx("span", { children: label }) })))] })) })), isEditButtonVisible
                && isSelected
                && (_jsx("div", Object.assign({ css: editButtonStyles }, { children: _jsx(Button, { disabled: 'disabled' in pickerOptionProps ? pickerOptionProps.disabled : undefined, expand: true, onClick: onEditClick, size: "small", text: "Edit" }) })))] })));
};
const MemoizedPhotoSelectPickerOption = memo(PhotoSelectPickerOption);
export { MemoizedPhotoSelectPickerOption as PhotoSelectPickerOption };
// MC-1068 Temporary hack for Storybook.
export default PhotoSelectPickerOption;
